module.exports = __webpack_public_path__ + "img/hygiene-and-appliances.62a67c76.jpeg";